import React, { ReactNode } from 'react'
import styled from 'styled-components'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

interface CustomToolTipProps {
    id?: string
    placement?: 'top' | 'bottom' | 'right' | 'left'
    tooltip: string | ReactNode
    className?: string
    widthInPX?: number
    textAlign?: 'left' | 'right' | 'justify' | 'center'
    delayShow?: number
    delayHide?: number
    hasIcon?: boolean
    children?: string | ReactNode
}

export function CustomToolTip({
    placement = 'top',
    id,
    className,
    tooltip,
    widthInPX,
    textAlign = 'left',
    delayShow = 0,
    delayHide = 0,
    hasIcon = true,
    children
}: CustomToolTipProps) {
    return (
        <OverlayTrigger
            placement={placement}
            delayShow={delayShow}
            delayHide={delayHide}
            overlay={
                <CustomTooltip widthInPX={widthInPX} textAlign={textAlign} className={className}>
                    {tooltip}
                </CustomTooltip>
            }
        >
            {(hasIcon && <Icon className={'far fa-info-circle'} />) || children}
        </OverlayTrigger>
    )
}

const Icon = styled.i`
    font-style: normal;
    font-size: 12px;
    line-height: 16px;
    color: ${({ theme }) => theme['blue-500']} !important;
    margin-left: 6px;
`

const CustomTooltip = styled(Tooltip)<{ widthInPX: number; textAlign: string }>`
    .tooltip-inner {
        max-width: ${({ widthInPX }) => widthInPX}px;
        width: ${({ widthInPX }) => widthInPX}px;
        text-align: ${({ textAlign }) => textAlign};

        background: var(--gray-800);
        padding: 8px 16px;
    }
`
